module.exports = __webpack_public_path__ + "img/upload-file.9b9e14bd.svg";